export const isPlayerFaction = (player, factionId) => {
  return player.factionId === factionId
}